<template>
  <transition name='modal'>
    <div v-if='show' class='modal-wrapper'>
      <div class='modal'>
        <div class='modal-body'>
          <p>We were not able to verify this address as a valid delivery destination.</p>

          <div class='modal-field'>{{ order.shipping_address.name }}</div>
          <div class='modal-field'>{{ order.shipping_address.address_1 }}</div>
          <div class='modal-field' v-if='order.shipping_address.address_2'>{{ order.shipping_address.address_2 }}</div>
          <div class='modal-field'>{{ order.shipping_address.city }}, {{ order.shipping_address.state }} {{ order.shipping_address.zipcode }}</div>
          <div class='modal-field'>{{ order.shipping_address.country }}</div>
          <br />
          <p>If this address is correct, please click continue.</p>
        </div>

        <div class='modal-actions'>
          <a @click.prevent='cancel' class='btn btn-cancel'>Edit Address</a>
          <a @click.prevent='submit_via_modal' class='btn'>Continue</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: ['show', 'order', 'cancel', 'submit_via_modal']
  }
</script>
